import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgIconSearch = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 18,
	height: 18,
	viewBox: "0 0 18 18",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("circle", {
		cx: 8,
		cy: 8,
		r: 5.2,
		stroke: "currentColor",
		strokeWidth: 1.6
	}), /* @__PURE__ */ _jsx("path", {
		d: "M12 12L15.5 15.5",
		stroke: "currentColor",
		strokeWidth: 1.6,
		strokeLinecap: "round"
	})]
});
export default SvgIconSearch;
